import React from 'react'
import { getCalendarEventDisplayName } from '../calendarDisplayUtils'
import CalendarEventHoverTooltip from '../CalendarEventHoverTooltip'
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const formatCompactTime = (time) => String(time || '')
  .replace(/:00\s*([AP]M)$/i, '$1')
  .replace(/\s*([AP]M)$/i, (_, period) => period.toLowerCase())

const LargeWeekViewEventChips = ({event, setEventToEdit, setEditEvent}) => {
  const [mouseOver, setMouseOver] = React.useState(false)
  const isCompactEvent = Number(event.lessonLength) <= 30
  const titleColor = event.isIntro ? 'text-amber-500' : event.color.textColor800
  const detailColor = event.isIntro ? 'text-amber-500' : event.color.textColor500
  const compactTime = formatCompactTime(event.time)
  const displayName = getCalendarEventDisplayName(event.name)

    const openEvent = (e) => {
        if(!e.isAvailabilityPlaceholder) {
          setEditEvent(true)
          setEventToEdit(e)
        }
      }
      

    return (
      <CalendarEventHoverTooltip event={event}>
        <li key={event.id} onClick={() => openEvent(event)} className={classNames(event.isPendingOffer && `animate-pulse`, `relative cursor-pointer flex transition-width duration-300  w-1/${event.column} col-start-${event.index} z-${Math.round(event.rowNumber)}`, mouseOver && `w-1/1`)} style={{ gridRow: `${event.rowNumber}/ ${event.rowNumber + event.rowLength}`}} onMouseEnter={() => setMouseOver(true)} onMouseLeave={() => setMouseOver(false)}>
          <div
            className={classNames(
              'calendar__week-event-card group border-solid',
              isCompactEvent && 'calendar__week-event-card--compact',
              event.isPendingOffer
                ? 'bg-gray-200 border-black'
                : event.isIntro
                  ? 'bg-amber-100'
                  : event.color.bgColor200,
              event.color.borderColor500
            )}
          >
            {isCompactEvent ? (
              <div className={`calendar__week-event-summary ${titleColor}`}>
                {event.isPendingOffer && <span className='calendar__week-event-pending'>Pending</span>}
                <span className='calendar__week-event-summary-name'>{displayName},</span>
                <time className='calendar__week-event-summary-time' dateTime={event.dateTime}>{compactTime}</time>
              </div>
            ) : (
              <>
                <div className='calendar__week-event-title-row'>
                  {event.isPendingOffer && <span className='calendar__week-event-pending'>Pending</span>}
                  <p className={`calendar__week-event-title ${titleColor}`}>{displayName}</p>
                </div>
                <p className={`calendar__week-event-details ${detailColor}`}>
                  <time dateTime={event.dateTime}>{event.time}</time>
                  <span>{event.lessonLength} min</span>
                </p>
              </>
            )}
          </div>
        </li>
      </CalendarEventHoverTooltip>
    )
}
export default LargeWeekViewEventChips;
